module.exports = __webpack_public_path__ + "img/NP4.ef172054.jpeg";